import { Component, inject, OnDestroy, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { stages } from '../../location-of-devices-unrelated-to-road.routes';
import { ApplicationAppEntityApplicationRead, RoadOccupationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';
import {
  LocationOfDevicesUnrelatedToRoadOccupationForm,
  LocationOfDevicesUnrelatedToRoadOccupationFormValue,
  occupationsToFormValue
} from './forms/location-of-devices-unrelated-to-road-occupation.form';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { AccordionGroupComponent } from '../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../common/accordion-item/accordion-item.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent
} from './components/location-of-devices-unrelated-to-road-occupation-preview/location-of-devices-unrelated-to-road-occupation-preview.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationFormComponent
} from './components/location-of-devices-unrelated-to-road-occupation-form/location-of-devices-unrelated-to-road-occupation-form.component';
import { updateLocationOfDevicesUnrelatedToRoadOccupations } from '../../../../../../store/actions/application.actions';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-section',
  standalone: true,
  imports: [
    StagesComponent,
    CommonModule,
    SpinnerComponent,
    AlertComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent,
    LocationOfDevicesUnrelatedToRoadOccupationFormComponent
  ],
  providers: [LocationOfDevicesUnrelatedToRoadOccupationForm],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-section.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationSectionComponent implements OnInit, OnDestroy {

  public stages: string[] = stages;

  private store$: Store = inject(Store);

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  public form: LocationOfDevicesUnrelatedToRoadOccupationForm = inject(LocationOfDevicesUnrelatedToRoadOccupationForm);

  public currentIndex: WritableSignal<number | undefined> = signal(undefined);

  public showItemForm: boolean = false;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public roadOccupations: WritableSignal<LocationOfDevicesUnrelatedToRoadOccupationFormValue[]> = signal([]);

  private fetchRoadOccupations: Subscription = toObservable(this.application).subscribe(app => {
    const occupations: Array<RoadOccupationAppEntityApplicationRead> = app?.roadOccupations || [];
    this.roadOccupations.set(occupationsToFormValue(occupations));
  });

  public onAdd(): void {
    this.showItemForm = true;
    this.currentIndex.set(undefined);
  }

  public onCancel(): void {
    this.router.navigate(['../inwestor'], { relativeTo: this.route });
  }

  public onEditOccupations(event: Event, i: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.currentIndex.set(i);
    this.showItemForm = true;
    this.form.patchFormValues({
      ...this.roadOccupations()[i]
    });
  }

  public onUpdateOccupations(roadOccupation: LocationOfDevicesUnrelatedToRoadOccupationFormValue): void {
    if (this.currentIndex() !== undefined) {
      this.roadOccupations.update(v => {
        const arr = [...v];
        arr[this.currentIndex() || 0] = roadOccupation;
        return arr;
      });
      this.currentIndex.set(undefined);
    } else {
      this.roadOccupations.update(v => ([
        ...v,
        roadOccupation
      ]));
    }
    this.showItemForm = false;
    this.form.reset();
  }

  public onRemove(i: number, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.roadOccupations.update(v => {
      v.splice(i, 1);
      return v;
    });
  }

  public submitAndGoNext(): void {
    if (this.roadOccupations().length) {
      this.store$.dispatch(
        updateLocationOfDevicesUnrelatedToRoadOccupations({
          application: this.application(),
          occupations: this.roadOccupations(),
          successFnc: (applicationId) => {
            this.router.navigate(
              ['../zgody'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    }
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.fetchRoadOccupations.unsubscribe();
  }
}
